// extracted by mini-css-extract-plugin
export default {"finalct":"final_finalct__i8kK-","final":"final_final__-9mBB","care__text":"final_care__text__adx9S","img_wrapper":"final_img_wrapper__Ahr1F"};